'use client'
import { useSearch } from 'storefront-modules/search/hooks'
import { useAppConfigContext } from '#/src/appConfig'
import { useGtmEvents } from 'storefront-modules/data-collection'

export const useCustomSearch = () => {
  const appConfig = useAppConfigContext()
  const { trackSearchEvent } = useGtmEvents()

  const onSubmit = (value: string) => {
    trackSearchEvent({ search_term: value })
  }

  return useSearch({
    config: {
      paths: {
        searchApi: '/api/search',
        searchPage: '/search'
      },
      onSubmit
    },
    searchQueryMinLength: appConfig.searchQueryMinLength
  })
}
